<template>
  <c-step
    :items="stepItems"
    :currentStepCd="currentStepCd"
    :param="param"
    v-model="stepCd"
    @closePopup="closePopup"
    @currentStep="currentStep"
    @keySetting="keySetting"
    @stepClick="stepClick"
  />
</template>

<script>
export default {
  name: 'chemUpdateDbUploadDetail',
  props: {
    popupParam: {
      type: Object,
      default() {
        return {
          mdmMaterialRegulatoryInfoExcelUploadId: '',
          statusCd: '',
        };
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      editable: true,
      stepCd: '', // 화면 스텝 코드(CUED*)
      currentStepCd: '', // 현재 진행 스텝 코드(CUED*)
      statusCd: '', // 업로드 상태코드(CEUS*)
      excelUploadId: '',
      searchProcess: {
        flag: '', // 재조회가 필요한 파일(API가 포함된 곳)에서 watch를 반응하게 하는 용도
        isSearch: false, // 저장/삭제 등 버튼성 이벤트가 일어날 때 true
      },
      stepItems: [
        {
          name: 'CUED000001',
          title: '엑셀 업로드',
          icon: 'upload_file',
          disabled: false,
          component: () => import(`${'./chemUpdateDbUploadExcel.vue'}`),
        },
        {
          name: 'CUED000005',
          title: '변경내용 확인',
          icon: 'fact_check',
          disabled: true,
          component: () => import(`${'./chemUpdateDbUploadCheck.vue'}`),
        },
      ],
    };
  },
  computed: {
    param() {
      return {
        mdmMaterialRegulatoryInfoExcelUploadId: this.excelUploadId,
        stepCd: this.stepCd,
        statusCd: this.statusCd,
        searchProcess: {
          flag: this.searchProcess.flag,
          isSearch: this.searchProcess.isSearch,
        },
      };
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code setting
      // list setting
      this.setStep(this.popupParam.statusCd);
      this.excelUploadId = this.popupParam.mdmMaterialRegulatoryInfoExcelUploadId || '';
    },
    /**
     * 상태코드(CEUS) → 화면 스텝코드(CUED) 매핑
     */
    setStep(status) {
      this.statusCd = status || 'CEUS000001';
      // CEUS000001: 엑셀 업로드 중 → CUED000001
      // CEUS000005: 변경내용 확인 중 / CEUS000010: 적용완료 → CUED000005
      // (하위 호환: 기존 CUED* 저장값도 동일 매핑)
      if (!status || status === 'CEUS000001' || status === 'CUED000001') {
        this.statusCd = 'CEUS000001';
        this.stepCd = 'CUED000001';
        this.currentStepCd = 'CUED000001';
      } else if (
        status === 'CEUS000005' ||
        status === 'CEUS000010' ||
        status === 'CUED000005' ||
        status === 'CUED000010'
      ) {
        this.statusCd = (status === 'CEUS000010' || status === 'CUED000010') ? 'CEUS000010' : 'CEUS000005';
        this.stepCd = 'CUED000005';
        this.currentStepCd = 'CUED000005';
      }
      this.popupParam.statusCd = this.statusCd;
    },
    /**
     * 현재 step(상태) 설정
     */
    currentStep(data) {
      this.excelUploadId = data.mdmMaterialRegulatoryInfoExcelUploadId || this.excelUploadId;
      // 하위 스텝에서 전달하는 값은 상태코드(CEUS*)
      this.setStep(data.statusCd || data.stepCd);
    },
    /**
     * 팝업 닫기
     */
    closePopup() {
      this.$emit('closePopup');
    },
    /**
     * 키 세팅
     */
    keySetting(_data) {
      this.excelUploadId = _data;
    },
    /**
     * 스텝 클릭 시 재조회 플래그 처리
     */
    stepClick() {
      if (this.param.searchProcess.isSearch) {
        this.searchProcess.flag = this.$_.uniqueId('search_');
        this.searchProcess.isSearch = false;
      }
    },
  }
};
</script>
